import React from "react";
import { Table } from "rsuite";

const CustomHeaderCell = (props: any) => {
  const { HeaderCell } = Table;
  return (
    <HeaderCell className="header-panel"
      {...props}
      style={{
        backgroundColor: "#8AD4FF",
      color: "#fff",
      padding: 4
      }}
    />
  );
};

export default CustomHeaderCell;
